export default "__VITE_ASSET__CzTCO$PG__"